export default "__VITE_ASSET__3PBHRRJy__"